import { Component, OnInit } from '@angular/core';
import { faPlus, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import { PromotionsService } from 'src/app/services/vehicle/promotions.service';
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { getEmptyGuid } from 'src/app/services/util.service'; // Asegúrate de que esta ruta es correcta
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-promotion-list',
  templateUrl: './promotion-list.component.html',
  styleUrls: ['./promotion-list.component.css']
})
export class PromotionListComponent implements OnInit {

  searchInput: string = "";
  promotions: any[] = [];
  filteredPromotions: any[] = [];

  // Icons imports
  faPlus = faPlus;
  faTrash = faTrash;
  faSearch = faSearch;

  tableHeaders = [
    { title: "", type: "checkbox", id: "IsChecked" },
    { title: "PROMOTION CODE", type: "link", id: "PromotionCode" },
    { title: "DESCRIPTION", type: "data", id: "Description" },
    { title: "STATUS", type: "data", id: "Status" },
    { title: "ID", type: "hidden", id: "PromotionFreeItemId" }
  ];

  constructor(
    private promotionsService: PromotionsService,
    private notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.getAllPromotions();
  }

  private getAllPromotions(): void {
    this.promotionsService.getAll().subscribe(
      (response) => {
        const promotions = Array.isArray(response?.body) ? response.body : [];
        this.promotions = promotions.map((promotion: any) => {
          return {
            "IsChecked": false,
            "PromotionCode": promotion.PromotionCode || "",
            "Description": promotion.Description || "",
            "Status": promotion.Status ? '✔️' : '',
            "PromotionFreeItemId": promotion.PromotionFreeItemId || ""
          };
        });
        this.filteredPromotions = [...this.promotions];
      },
      (error: any) => {
        console.error("Error fetching promotion data:", error);
        this.notifier.notify('error', 'Error loading promotions.');
      }
    );
  }

  onSearch(searchValue: string): void {
    const lowerCaseSearch = searchValue.toLowerCase();
    this.filteredPromotions = this.promotions.filter(item =>
      item.PromotionCode.toLowerCase().includes(lowerCaseSearch) ||
      item.Description.toLowerCase().includes(lowerCaseSearch)
    );
  }

  async deleteSelectedPromotions(): Promise<void> {
    const selectedItems = this.promotions
      .filter(item => item.IsChecked)
      .map(item => ({
        PromotionFreeItemId: item.PromotionFreeItemId,
      }));

    if (selectedItems.length === 0) {
      this.notifier.notify('error', 'Please select at least one promotion to delete.');
      return;
    }

    const confirmed = await this.dialogService.openConfirmDialog(
      'Confirm Action',
      'Are you sure you want to delete record(s)?',
      'Yes',
      'No',
      'confirm',
    );
    if (!confirmed) {
      return;
    }

    this.promotionsService.deletePromotionFreeItems(selectedItems).subscribe({
      next: (response) => {
        if (response.code !== 0 || response.statusCode < 200 || response.statusCode >= 300) {
          this.notifier.notify('error', response.message || 'The selected promotions were not deleted.');
          return;
        }

        const deletedIds = new Set(selectedItems.map(item => item.PromotionFreeItemId));
        this.promotions = this.promotions.filter(
          item => !deletedIds.has(item.PromotionFreeItemId),
        );
        this.filteredPromotions = this.filteredPromotions.filter(
          item => !deletedIds.has(item.PromotionFreeItemId),
        );
        this.notifier.notify('success', 'Promotion Free Item record(s) deleted successfully.');
      },
      error: (error: any) => {
        console.error("Error deleting promotions:", error);
        this.notifier.notify('error', 'Error deleting selected promotions.');
      }
    });
  }

  openEntry(value: any): void {
    const promotionId = value.PromotionFreeItemId; 
    this.router.navigate([`../promotion-free-item`, promotionId], {
      relativeTo: this.route,
    });
  }

  addEntry(): void {
    const emptyGuid = getEmptyGuid(); 
    this.router.navigate([`../promotion-free-item`, emptyGuid], {
      relativeTo: this.route,
    });
  }
}
